export enum MeetingBodies {
    PLENARY = 'plenary',
    C1 = 'c1',
    C2 = 'c2',
    C3 = 'c3',
    C4 = 'c4',
    C5 = 'c5',
    WGSR = 'wgsr',
    FFD4PC = 'ffd4pc',
    UNGEGN = 'ungegn',
    CPD = 'cpd',
    STATSCOMM = 'statscomm',
    CNGOS = 'cngos',
    UNDC = 'undc',
    GGIM = 'ggim',
    UNPFII = 'unpfii',
    UNFF = 'unff',
    CSW = 'csw',
    C34 = 'c34',
    C24 = 'c24',
    FFD = 'ffd',
    FFD4 = 'ffd4',
    HLPF = 'hlpf',
    CSOCD = 'csocd',
    BMS = 'bms',
    UNWRAPC = 'unwrapc'
}
